module.exports = __webpack_public_path__ + "static/media/hn.db7e3de4.svg";